import { render, staticRenderFns } from "./FixBrokenLinks.vue?vue&type=template&id=4d7916fe"
import script from "./FixBrokenLinks.vue?vue&type=script&lang=js"
export * from "./FixBrokenLinks.vue?vue&type=script&lang=js"
import style0 from "./FixBrokenLinks.vue?vue&type=style&index=0&id=4d7916fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports